module nullstone {
    export var version = '0.4.8';
}